module.exports = __webpack_public_path__ + "static/media/im.07fac2af.svg";